module.exports = __webpack_public_path__ + "static/media/search.d71d6abf.svg";